import {useEffect} from 'react'

function useMount(fn: Function) {
  function callback() {
    const response = fn()
    if (typeof response === 'function') return response
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [])
}

export default useMount
